import { useState, useRef, useEffect } from 'react'
import { cn } from '@/lib/utils'
import { Download, FileText, Mail, Printer } from 'lucide-react'

interface QuickExportProps {
  className?: string
}

export function QuickExport({ className }: QuickExportProps) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const exportOptions = [
    {
      key: 'pdf',
      label: 'Export as PDF',
      icon: FileText,
      action: () => console.log('Export as PDF'),
    },
    {
      key: 'email',
      label: 'Email Forward',
      icon: Mail,
      action: () => console.log('Email forward'),
    },
    {
      key: 'print',
      label: 'Print',
      icon: Printer,
      action: () => console.log('Print'),
    },
  ]

  const handleExportOption = (action: () => void) => {
    action()
    setIsOpen(false)
  }

  return (
    <div className={cn('relative', className)} ref={dropdownRef}>
      {/* Quick Export Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 rounded-lg hover:bg-muted transition-colors"
        title="Quick Export"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <Download className="w-4 h-4" />
      </button>

      {/* Export Options Dropdown */}
      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-48 bg-card border border-border rounded-lg shadow-lg z-50">
          <div className="py-2">
            <div className="px-3 py-1 text-xs font-medium text-muted-foreground border-b border-border mb-1">
              Export Latest Briefing
            </div>
            {exportOptions.map((option) => (
              <button
                key={option.key}
                onClick={() => handleExportOption(option.action)}
                className="w-full flex items-center space-x-3 px-3 py-2 text-sm text-left hover:bg-muted transition-colors"
              >
                <option.icon className="w-4 h-4" />
                <span>{option.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}